import { PRICE_TYPES } from 'shared/consts/productTemplates.js'

import getImageUrl from 'views/components/organisms/AlgoliaInstantSearch/Algolia/getImageUrl'

export function calculateRetailPrice(amount) {
  return amount / 100
}

const processElasticSuggestion = ({ price, id, ...rest }) => {
  const { retailPrice: { amount } = {} } = price || {}
  return {
    ...rest,
    id,
    deeplink: `products/${id}`,
    prices: [
      {
        amount,
        type: PRICE_TYPES.RETAIL
      }
    ]
  }
}

/**
 * Add additional URL parameters to the deeplink
 */
const processAlgoliaDeeplink = ({
  queryID,
  query,
  position,
  product: { pzn, deeplink } = {}
}) => {
  const params = [
    `query=${query}`,
    `queryID=${queryID}`,
    `objectIDs=[${pzn}]`,
    `position=${position + 1}`,
    `eventName=${decodeURIComponent('click on product in suggest')}`,
    'eventType=click'
  ].join('&')

  return `${deeplink}?${params}`
}

const processAlgoliaSuggestion = props => {
  const {
    product,
    product: { productName: name, pzn: id, price, stockStatus },
    cdnUrl
  } = props

  return {
    id,
    deeplink: processAlgoliaDeeplink(props),
    name,
    prices: [
      {
        amount: price && calculateRetailPrice(price),
        type: PRICE_TYPES.RETAIL
      }
    ],
    stockStatus: { status: stockStatus },
    thumbnailURL: getImageUrl({ product, cdnUrl })
  }
}

export function mapEStoSuggestResults({ content }) {
  return {
    suggestions: content.map(processElasticSuggestion)
  }
}

export function mapAlgoliaToSuggestResults({
  hits: products,
  query,
  queryID,
  abTestID,
  abTestVariantID,
  cdnUrl
}) {
  return {
    suggestions: products.map((product, position) =>
      processAlgoliaSuggestion({
        queryID,
        query,
        product,
        position,
        cdnUrl
      })
    ),
    abTestID,
    abTestVariantID
  }
}
